import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {SidebarService} from '../shared/services/sidebar.service';
import {AuthTokenService} from '../shared/services/auth-token.service';
import {DashboardMenuModel} from "../models/dashboard/dashboard.model";
import {DashboardService} from "../routes/dashboard/dashboard.service";
import {CommunicationService} from "../shared/services/communication.service";

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.less']
})
export class SideMenuComponent implements OnInit {
  // menuData: DashboardMenuModel;
  isAdmin: boolean;
  isCommon: boolean;
  collapsedSidebar = false;

  @Output()
  closeSideBar = new EventEmitter();

  constructor(public router: Router,
              public sidebarService: SidebarService,
              private dashboardService: DashboardService,
              private authTokenService: AuthTokenService,
              private communicationService: CommunicationService) {

  }

  ngOnInit() {

    this.sidebarService.close$.subscribe(() => {
      this.collapsedSidebar = true;
      this.closeSideBar.emit(this.collapsedSidebar);
    });
    this.sidebarService.toggle$.subscribe(() => {

      this.collapsedSidebar = !this.collapsedSidebar;
      this.closeSideBar.emit(this.collapsedSidebar);
    });
    this.isAdmin = AuthTokenService.isAdmin();
    this.isCommon = AuthTokenService.isUser();

    this.dashboardService.getMenuData()
      .subscribe((response) => {
          // this.menuData = response;
          this.sidebarService.menuData = response;
        },
        (error) => {
          // console.log(error);
        })
  }


}



// WEBPACK FOOTER //
// ./src/app/side-menu/side-menu.component.ts